import { forwardRef, memo } from 'react';

import { cn } from '../../lib/styles';

interface TableTileProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  children: React.ReactNode;
  right?: React.ReactNode;
}

const TableTitleBase = ({ children, className, right, ...rest }: TableTileProps, ref: React.Ref<HTMLDivElement>) => {
  return (
    <div ref={ref} className={cn('flex items-center gap-4 justify-between px-6 pt-6 pb-4', className)} {...rest}>
      <h3 className="font-heading-2xl font-semibold text-text-primary">{children}</h3>

      {right}
    </div>
  );
};

export const TableTitle = memo(forwardRef(TableTitleBase));
